import React from 'react';
import { Drawer, Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import MarkDown from '../Markdown';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const TextPreviewDrawer = ({
  visible,
  onClose,
  content,
  title,
  noContentMessage
}) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Drawer
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{title}</span>
        </div>
      }
      placement="right"
      width={isMobile ? "100%" : "50%"}
      onClose={onClose}
      open={visible}
    >
      <div>
        <div>
          <div style={{ 
            backgroundColor: '#fafafa', 
            padding: '16px', 
            borderRadius: '6px',
            border: '1px solid #e8e8e8',
            overflow: 'auto',
            color: '#333',
            fontSize: '15px',
            maxHeight: '70vh'
          }}>
            {content ? (
              <MarkDown content={content} />
            ) : (
              <Text type="secondary">{noContentMessage}</Text>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default TextPreviewDrawer; 